import React, { useRef, forwardRef, useImperativeHandle, memo, cloneElement } from "react"
import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import { Button, Grid, Divider } from "@material-ui/core"
import Toolbar from "@material-ui/core/Toolbar"
import useScrollTrigger from "@material-ui/core/useScrollTrigger"
import logo from "@/assets/images/sparca-logo.png"
import { Link as RouterLink } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: "flex",
    },
    paper: {
        padding: theme.spacing(5, 4),
        margin: "auto",
        maxWidth: "100%",
        width: "100%",
    },
    appBar: {
        backgroundColor: "#ffffff",
        "& .right-side > *": {
            marginLeft: theme.spacing(2),
        },
        borderBottom: theme.palette.sparcaLightGrey.main,
    },
    popoverPaper: {
        [theme.breakpoints.up("sm")]: {
            marginTop: "45px",
        },
        marginTop: "30px",
    },
    linkedPrimary: {
        color: "#000000",
        "&:hover": {
            color: theme.palette.primary.main,
            background: "none",
        },
    },
    noDecoration: {
        textDecoration: "none",
    },
    logo: {
        margin: theme.spacing(1, 0),
    },
}))

function ElevationScroll(props) {
    const { children, window } = props
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    })

    return cloneElement(children, {
        elevation: trigger ? 4 : 0,
    })
}

const Header = memo(
    forwardRef((props, ref) => {
        const classes = useStyles()
        const headerRef = useRef(null)
        useImperativeHandle(ref, () => ({
            getHeaderHeight: () => {
                return headerRef.current.offsetHeight
            },
        }))

        const CCSiteURL = process.env.CC_MAIN_SITE

        return (
            <>
                <ElevationScroll>
                    <AppBar className={classes.appBar}>
                        <Toolbar ref={headerRef}>
                            <Grid container direction="row" justify="space-between" alignItems="center">
                                <Grid className="left-side" item>
                                    <RouterLink to="/login">
                                        <img className={classes.logo} src={logo} alt="sparca-logo" />
                                    </RouterLink>
                                </Grid>
                                <Grid className="right-side" item>
                                    <Button href={`${CCSiteURL}/products/dashboard-help/`} className={classes.helpLink}>
                                        Need Help?
                                    </Button>
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                </ElevationScroll>
                <Toolbar />
                <Divider />
            </>
        )
    })
)

export default Header
